import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useSmartState from '../../../common/hooks/useSmartState';
import { getStudentImage } from '../../../common/styles/Images';
import { SmartContext } from '../../../library/Core/SmartContext';
import { getDomainValueForCode, isEmpty, handleCopyText, getFlexColDomainValueForCode } from '../../../library/Core/SmartFunctions';
import { FormControl, FormSection } from '../../../library/Core/SmartTypes';
import ActionSettings from '../../../library/SimpleControls/ActionSettings';
import ExportToExcel from '../../../library/SimpleControls/ExportToExcel';
import BasAdminReportService from './BasAdminReportService';
import useInternalAdminReports from './useInternalAdminReports';
import SessionContext from '../../../library/Core/SessionContext';
import AssignSession from '../../student/view/sections/AssignSession';
import { REPORT_CONFIG } from '../reports/report-config';
import { axiosClient } from '../../../library/Service/axiosClient';
import { Modal, Button } from 'react-bootstrap';   


//import 'bootstrap/dist/css/bootstrap.min.css';

const BATCH_SIZE = 10;

const Results = () => {
    const { state, dispatch } = useContext(SmartContext);
    const allRowsData = state.data.alumniList ?? [];

    const [bulkAction, setBulkAction] = useState<string>('' as any);
    const { setStateValue } = useSmartState();
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const { getFormattedDate, activateAlumni, deactivateAlumni, validateAlumni,verifyEmail, deleteUser } = useInternalAdminReports();
    const resultsFormConfig = state.formConfig?.sectionRepository[1] as FormSection;
    const config = REPORT_CONFIG[state.routeInfo.pageName];
    const loadMoreRef = useRef(null);
    const [pageData, setPageData] = useState([] as any[]);
    const getActionLabel = (code: string) => code.toLowerCase().replace(/_/g, ' ');
    const navigate = useNavigate();
    const { sessionState } = useContext(SessionContext);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSelectRow = (event: any) => {
        if (event.target.checked) setSelectedRows((prev) => [...prev, event.target.value]);
        else setSelectedRows((prev) => prev.filter((id) => id !== event.target.value));
    };

    const handleSelectAll = (event: any) => {
        const students = event.target.checked ? allRowsData.map((item: any) => item.uuid) : [];
        setSelectedRows(students);
    };

    const getTagline = (row: any) => {
        if (!isEmpty(row.twelvethPassoutYear)) {
            return `${row.programName} - ${row.twelvethPassoutYear}`;
        } else if (!isEmpty(row.programName)) {
            return `${row.programName}`;
        } else {
            return '';
        }
    };

    useEffect(() => {
        setPageData([...allRowsData.slice(0, BATCH_SIZE)]);
    }, [state.data.alumniList]);

    useEffect(() => {
        console.log(state.data.alumniList, 'alumniList data 61')
    }, []);

    useEffect(() => {
        const loadMoreObserver = new IntersectionObserver((entries) => {
            if (allRowsData.length <= pageData.length) {
                if (loadMoreRef.current) loadMoreObserver.unobserve(loadMoreRef.current);
                return;
            }

            if (entries[0].isIntersecting) {
                const nextBatch = allRowsData.slice(0, pageData.length + BATCH_SIZE);
                setPageData([...nextBatch]);
            }
        });

        if (loadMoreRef.current) loadMoreObserver.observe(loadMoreRef.current);

        return () => {
            if (loadMoreRef.current) {
                loadMoreObserver.unobserve(loadMoreRef.current);
            }
        };
    }, [loadMoreRef, pageData]);

    const getAlumniNameField = (row: any) => {
        return (

            <div className="d-flex flex-column checkoption">
                {config['SHOW_SELECT_ALL'] && (
                    <input
                        className="form-check-input me-2 StudentId"
                        name="uuid"
                        type="checkbox"
                        value={row.uuid}
                        checked={selectedRows.includes(row.uuid)}
                        onChange={handleSelectRow}
                    />
                )}
                <a
                    className="tablink"
                    href={`/alumni/${row.uuid}/profile`}
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="me-2 position-relative">
                        <img src={getStudentImage(row)} className="rounded-circle img-fluid" width="30" />
                        {showStar(row) && <i className="icon-star circle-img"></i>}
                    </i>
                    <span
                        data-bs-toggle="tooltip"
                        title={`${row.name}`}
                        className="singlelinename font-16 lineHeight-16">
                        {row.name}
                        <span className="d-block font-13 fst-italic"> {getTagline(row)} </span>
                    </span>
                </a>
                <div className="copyId d-flex align-items-center mt-1">
                    <span className="font-13 fst-italic singlelinename me-1"> {row.uuid} </span>
                    <button
                        id={`uuid-${row.uuid}`}
                        className="copy-text border-0 bg-transparent"
                        title="click to copy id"
                        onClick={() => handleCopyText(row.uuid, `uuid-${row.uuid}`)}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-copy"
                            viewBox="0 0 16 16">
                            <path
                                fill-rule="evenodd"
                                d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        );
    };

    const getShortenedSchoolName = (row: any): any => {

        if (!row?.schoolName || typeof row.schoolName !== 'string') {
            // Gracefully handle missing/invalid schoolName
            return <span style={{ color: 'gray' }}>N/A</span>;
        }
        const parts = row?.schoolName.split(',');
        const schoolNameContent =
            parts.length > 1 ? (
                <>
                    <span>
                        {parts[0]},<br />
                        {parts.slice(1).join(',').trim()}
                    </span>
                </>
            ) : (
                <>{row.schoolName}</>
            );

       

        // If condition is not satisfied, display just the school name text
        return schoolNameContent;
    };

    const [showCloseCaseModal, setShowCloseCaseModal] = useState(false);
const [comment, setComment] = useState('');
const [selectedUser, setSelectedUser] = useState<string | null>(null);

const handleCloseCase = async () => {
    try {
      const response = await axiosClient().post(`${process.env.REACT_APP_BAS_API}/counsellorsession/close-case-update`, {
        id: selectedUser,
        status: 1,
        message: comment,
      });
  
      toast.success(response.data.message || 'Case closed successfully!');
      setShowCloseCaseModal(false);
      setComment('');
      setSelectedUser(null);
  
      // Refresh list
      BasAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
        setStateValue('alumniList', response.data);
      });
    } catch (error) {
      console.error(error);
      toast.error('Failed to close the case.');
    }
  };
  

    const getActionNode = (control: FormControl, row: any) => {
        const actions = config['ROW_ACTION'].filter((action: any) => {  
            if(!['SCHEDULE','RE-SCHEDULE'].includes(action)) return true; // Skip if no action is defined

            const latestSession = row?.counsellingSessions?.reduce((maxSession: any, session: any) => {
            return !maxSession || session.stage > maxSession.stage ? session : maxSession;
            }, null);

            if(!latestSession) return action === 'SCHEDULE' ? true : false; // If no session, allow scheduling

            //   console.log(latestSession, 'latestSession');

            const appointmentFrom = !isEmpty(latestSession) ? new Date(new Date(latestSession?.appointmentFrom).getTime() + 330 * 60000) : new Date();
            const appointmentTo = !isEmpty(latestSession) ? new Date(new Date(latestSession?.appointmentTo).getTime() + 330 * 60000) : new Date();

            //   console.log(appointmentFrom,  'appointmentFrom',appointmentTo, 'appointmentTo');
            let flag = false;

            if(row.basCloseCase === 1) return false; // If case is closed, no actions allowed
            
            if((latestSession && !['SCHEDULED','COMPLETED'].includes(latestSession?.status) && ((new Date(appointmentTo).getTime() < new Date().getTime()) || ['CANCELLED'].includes(latestSession?.status))) && action === 'SCHEDULE') {
            flag = true;
            }

            if((latestSession && ['SCHEDULED','RE-SCHEDULED'].includes(latestSession?.status) && ((new Date(appointmentFrom).getTime() - new Date().getTime()) > 60 * 60 * 1000)) && action === 'RE-SCHEDULE') {
            flag = true;
            }
            return flag;
        });

      return row.basCloseCase === 1 ? (
        <span style={{ color: 'red', fontWeight: 'bold' }}>Closed Case</span>
      ) : actions.length > 0 ? (
        <ActionSettings
          id={row}
          actions={actions}
          onClick={handleAction}
          onCloseCase={(row: { uuid: string }) => {
            setSelectedUser(row.uuid);
            setComment('');
            setShowCloseCaseModal(true);
          }}
        />
      ) : null;
      
    }
      

    // const getActionNode = (control: FormControl, row: any) => {
    //     const actions = config['ROW_ACTION'].filter((action: any) => {
    //         let flag = true;
    //         if (row.isPeerReviewed == 1 && action === 'VALIDATE') flag = false;
    //         if (row.isEmailVerified === 1 && action === 'VERIFY_EMAIL') flag = false;
    //         // if (row.userStatusCode === 'ACTIVE' && action === 'ACTIVATE') return false;
    //         if (row.userStatusCode !== 'INACTIVE' && action === 'ACTIVATE') flag = false;
    //         if (row.userStatusCode === 'INACTIVE' && action === 'DEACTIVATE') flag = false;
    //         if(action == 'UPDATE') flag = false;
    //         if(row.userStatusCode == 'RAW_PROFILE') flag = action == 'UPDATE' ? true : false;
    //         return flag;
    //     });

    //     return actions.length > 1 ? (
    //         <ActionSettings id={row} actions={actions} onClick={handleAction} />
    //     ) : (
    //         <a className="btn-update" href={config['UPDATE_ACTION_LINK'](row.uuid)} target="_blank" rel="noopener noreferrer">
    //             Update
    //         </a>
    //     );
    // };



    const handleAction = (row: any, action: string) => {
        if (action === 'CLOSE_CASE') {
          setSelectedUser(row.uuid);
          setComment('');
          setShowCloseCaseModal(true);
        } else {
          handlePerformAction(action, [row]);
        }
      };

  const getParentInfo = (row: any): any => {
    const schoolNameContent = row?.parentDetails ? (
        <>
            {row.parentDetails.split(',').map((part: string, index: number, array: string[]) => (
                <div key={index}>
                    <a
                        href={`/alumni/${row?.uuid}/profile/parent-info`}
                        target="_blank"
                        rel=""
                        style={{ textDecoration: 'none' }} 
                    >
                        {part.trim()}
                    </a>
                    {index < array.length - 1 && ','}
                </div>
            ))}
        </>
    ) : (
        <>N/A</>
    );
    return schoolNameContent;
};


const getTestApplicable = (row: any): JSX.Element => {
    
    const baseUrl = `${process.env.REACT_APP_APP_BASE_URL}/`;
  const getStatus = (sessions: any[]): JSX.Element[] => {
    const statusMap: Record<string, { status: string; item: any }> = {};

    // 🔥 Remove testCode === 1
    const filteredSessions = sessions.filter((s) => s.testCode !== 1);

    filteredSessions.forEach((session) => {
      const { testName, startDate, endDate } = session;
      const hasStart = !!startDate;
      const hasEnd = !!endDate;

      if (!statusMap[testName]) {
        let status = 'Not Taken';
        if (hasEnd) status = 'Completed';
        else if (hasStart) status = 'Started';

        statusMap[testName] = { status, item: session };
      } else {
        const currentStatus = statusMap[testName].status;
        if (currentStatus === 'Not Taken' && hasStart) {
          statusMap[testName] = { status: 'Started', item: session };
        }
        if (currentStatus !== 'Completed' && hasEnd) {
          statusMap[testName] = { status: 'Completed', item: session };
        }
      }
    });

    return Object.entries(statusMap).map(([name, { status, item }]) => {
      let encodedPath = '';
      const testCode = item.testCode;

      switch (testCode) {
        case 101:
          encodedPath = 'cHN5Y2hvbWV0cmljX3Rlc3QvY2FyZWVyR3VpZGUvTGVhcm5pbmdzdHlsZXRlc3Q=';
          break;
        case 100:
          encodedPath = 'cHN5Y2hvbWV0cmljX3Rlc3QvY2FyZWVyR3VpZGUvTXVsdGlwbGVJbnRlbGxpZ2VuY2VUZXN0';
          break;
        case 104:
          encodedPath = 'cHN5Y2hvbWV0cmljX3Rlc3QvY2FyZWVyR3VpZGUvUGVyc29uYWxpdHlUZXN0';
          break;
        case 115:
          encodedPath = 'cHN5Y2hvbWV0cmljX3Rlc3QvY2FyZWVyR3VpZGUvU3RyZWFtU2VsZWN0b3JUZXN0';
          break;
        case 114:
          encodedPath = 'cHN5Y2hvbWV0cmljX3Rlc3QvY2FyZWVyR3VpZGUvSWRlYWxjYXJlZXJ0ZXN0';
          break;
        default:
          encodedPath = btoa('profile');
      }

      const userHash = row?.userHash || '';
      const profileLink = `${baseUrl}sso/${userHash}/${encodedPath}`;

        return (
            // style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}
            <div key={name} className='d-flex flex-wrap mb-2'>
            <strong className='d-block'>{name}:</strong>
            <span className='me-2'>{status}</span>
            {(status === 'Completed' || status === 'Started' || status === 'Not Taken') && (
            <i
                className="bi bi-copy font-14"
                style={{ color: '#007bff', cursor: 'pointer' }}
                title="Copy Test Link"
                onClick={() => {
                navigator.clipboard.writeText(profileLink);
                alert('Test link copied to clipboard!');
                }}
            ></i>
            )}
            </div>
        );
        });
    };

    const sessions = row?.psychometricSessions?.filter((s: any) => s.testCode !== 1);

    if (Array.isArray(sessions) && sessions.length > 0) {
        return <div>{getStatus(sessions)}</div>;
    }

    return <span style={{ color: 'gray' }}>No Tests Assigned</span>;
    };

    const renderBookingLink = (bookingUrl: string, id: string | number) => (
    <div className="d-flex align-items-center mt-1">
        <a
        href={bookingUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="me-2"
        >
        Booking Link
        </a>

        <button
        id={`copy-booking-${id}`}
        className="copy-text border-0 bg-transparent"
        title="Click to copy booking link"
        onClick={() => handleCopyText(bookingUrl, `copy-booking-${id}`)}
        >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-copy"
            viewBox="0 0 16 16"
        >
            <path
            fillRule="evenodd"
            d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
            />
        </svg>
        </button>
    </div>
    );

 const getCounsellingInfo = (row: any): JSX.Element => {
    const sessions = row?.counsellingSessions || [];
    const bookingUrl = `${process.env.REACT_APP_APP_BASE_URL}/sso/${row?.userHash}/YmFz`;

    const maxSentStage = sessions
        .filter((s: any) => s.status?.toUpperCase() === "SD_SENT")
        .reduce((max: number, s: any) => Math.max(max, parseInt(s.stage ?? 0)), 0);

    const nextStage = maxSentStage > 0 ? maxSentStage + 1 : 0;

    const hasNextStageSession = sessions.some(
        (s: any) => parseInt(s.stage ?? 0) === nextStage
    );

    const showNextStageBooking = nextStage > 0 && !hasNextStageSession;

    return (
        <div className="counselling-info-wrap">
            {sessions.length > 0 ? (
                <>
                    {[...sessions]
                        .sort((a, b) => parseInt(a.stage ?? 0) - parseInt(b.stage ?? 0))
                        .map((session: any, idx: number) => {
                            const {
                                stage,
                                status,
                                createdAt,
                                appointmentFrom,
                                counsellorId,
                                counsellorName,
                                appointmentLink,
                                sessionLink,
                            } = session;

                            return (
                                <div key={idx} className="stage-info mb-2">
                                    {/* Counsellor Info */}
                                    {counsellorId && counsellorName ? (
                                        <div className="counsellor-line">
                                            <a
                                                href={`/support/all-bas-report/${counsellorId}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <strong>{counsellorName} </strong>
                                            </a>{" "}
                                            (<span className="text-muted">{formatDateOnly(createdAt)}</span>)
                                        </div>
                                    ) : (
                                        <div>NA</div>
                                    )}

                                    <div>
                                        <strong>{`CS${stage}`} </strong>{" "}
                                        <span className="text-muted">
                                            ({formatStatus(status)} -{" "}
                                            {appointmentFrom && <span>{formatDate(appointmentFrom)}</span>})
                                        </span>
                                    </div>

                                    {["SCHEDULED", "BOOKED","RE-SCHEDULED"].includes(status?.toUpperCase()) && (
                                        <div className="mt-1">
                                            <a
                                                href={appointmentLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="me-2"
                                            >
                                                Counsellor Link
                                            </a>
                                            <div className="d-flex align-items-center mt-1">
                                                <a
                                                    href={sessionLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Student Link
                                                </a>
                                                <button
                                                    id={`copy-session-${idx}`}
                                                    className="copy-text border-0 bg-transparent ms-2"
                                                    title="Click to copy session link"
                                                    onClick={() => handleCopyText(sessionLink, `copy-session-${idx}`)}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-copy"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {(status?.toUpperCase() === "MISSED" || status?.toUpperCase() === "CANCELLED") && (
                                        <>
                                            {status?.toUpperCase() === "MISSED" && (
                                            <div className="text-danger mt-1">Reschedule Required</div>
                                            )}
                                            {renderBookingLink(bookingUrl, row?.uuid)}
                                        </>
                                    )}


                                    {status?.toUpperCase() === "COMPLETED" && (
                                        <div className="mt-2">
                                            <a
                                                href={`/alumni/${row?.uuid}/profile/sessions`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn-conview"
                                            >
                                                SEND SD
                                            </a>
                                        </div>
                                    )}
                                </div>
                            );
                        })}

                    {showNextStageBooking && (
                        <div>
                            <span className="d-block mb-1">
                                <strong>{`CS${nextStage} - Ready to Book`}</strong>
                            </span>
                            {renderBookingLink(bookingUrl, row?.uuid)}
                        </div>
                    )}
                </>
            ) : (
                <div>
                    <span className="d-block mb-1">
                        <strong>CS1 - Ready to Book</strong>
                    </span>
                    {renderBookingLink(bookingUrl, row?.uuid)}
                </div>
            )}
        </div>
    );
};


    const formatStatus = (status: string): string => {
        switch (status) {
            case "BOOKED":
                return "Booked";
            case "MISSED":
                return "Missed";
            case "CANCELLED":
                return "Cancelled";
            case "COMPLETED":
                return "Completed";
            case "READY_TO_BOOK":
                return "Ready to Book";
            case "SD_SENT":
                return "SD SENT";
            default:
                return status?.charAt(0).toUpperCase() + status?.slice(1).toLowerCase();
        }
    };

    const formatDateOnly = (dateString: string): string => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDate = (dateStr: string) => {
      const date = new Date(new Date(dateStr).getTime() + 330 * 60000); // Convert to IST manually
    
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = date.getFullYear();
    
      const time = date.toLocaleTimeString('en-IN', {
        timeZone: 'Asia/Kolkata',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    
      return `${day}-${month}-${year} ${time}`;
    };


    const getConversations = (row: any): any => {
        if (!row?.schoolName || typeof row.schoolName !== 'string') {
            // Gracefully handle missing/invalid schoolName
            return <span style={{ color: 'gray' }}>N/A</span>;
        }
        const parts = row?.schoolName.split(',');
        const schoolNameContent =
            parts.length > 1 ? (
                <>
                    <span>
                        {parts[0]},<br />
                        {parts.slice(1).join(',').trim()}
                    </span>
                </>
            ) : (
                <>{row.schoolName}</>
            );

        if (state.routeInfo.pageName === 'internal-admin-all-school-summary') {
            return (
                <a className="tablink" href={`/support/all-alumni-report/${row.schoolId}`} target="_blank" rel="noopener noreferrer">
                    {schoolNameContent}
                </a>
            );
        }
        // If condition is not satisfied, display just the school name text
        return schoolNameContent;
    };
    

    const getFieldNode = (control: FormControl, row: any) => {
        let content;

        switch (control.id) {
            case 'studentName':
                content = getAlumniNameField(row);
                break;
            case 'campus':
                content = getShortenedSchoolName(row);
                break;
            case 'parentInfo':
                content = getParentInfo(row);
                break;
            case 'testApplicable':
                content = getTestApplicable(row);
                break;
            case 'counsellingInfo':
                content = getCounsellingInfo(row);
                break;
            case 'conversations':
                content = getConversations(row);
                break;
            case 'buttons':
                content = getActionNode(control, row);
                break;
            case 'createdAt':
            case 'updatedAt':
                content = getFormattedDate(row[control.id]);
                break;
            default:
                if (control.props?.domainCategoryCode?.length > 0)
                    content = getDomainValueForCode(row[control.id], control.props.domainCategoryCode, state);
                else content = row[control.id];
        }

        return (
            <td key={control.id} className={control.className}>
                {content}
            </td>
        );
    };

    const handlePerformAction = async (action: string, students: any) => {
        switch (action) {
            case 'UPDATE_3C':
                setSelectedRows([]);
                if (students.length > 0 && students[0].uuid) {
                    window.open(`/alumni/${students[0].uuid}/profile/preference`, '_blank', 'noopener,noreferrer');
                }
                break;
            case 'SCHEDULE':
            case 'RE-SCHEDULE':
                setSelectedRows([]);
                if (students.length > 0 && students[0].uuid) {
                    window.open(`/alumni/${students[0].uuid}/bas`, '_blank', 'noopener,noreferrer');
                }
                break;
            // case 'RE-ASSIGN':
            //     await deactivateAlumni(students);
            //     setSelectedRows([]);
            //     BasAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
            //         setStateValue('alumniList', response.data);
            //         fetchAlumniCount(state);
            //         toast.success('De-activated successfully');
            //     });
            //     break;
            case 'VIEW_HISTORY':
                setSelectedRows([]);
                // Open the profile page of the first student (or handle multiple as needed)
                if (students.length > 0 && students[0].uuid) {
                    window.open(`/alumni/${students[0].uuid}/profile/counselling-logs`, '_blank', 'noopener,noreferrer');
                }
                break;
            case 'VIEW_NOTES':
                setSelectedRows([]);
                // Open the profile page of the first student (or handle multiple as needed)
                if (students.length > 0 && students[0].uuid) {
                    window.open(`/alumni/${students[0].uuid}/profile/counsellor-notes`, '_blank', 'noopener,noreferrer');
                }
                break;
            case 'MAKE_STUDENT_/_PARENT_PRIMARY':
                await deactivateAlumni(students);
                setSelectedRows([]);
                BasAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
                    setStateValue('alumniList', response.data);
                    fetchAlumniCount(state);
                    toast.success('De-activated successfully');
                });
                break;
            case 'RAISE_REMOVAL_REQUEST':
                await deactivateAlumni(students);
                setSelectedRows([]);
                BasAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
                    setStateValue('alumniList', response.data);
                    fetchAlumniCount(state);
                    toast.success('De-activated successfully');
                });
                break;
            
            
        }
    };

    const fetchAlumniCount = async (state: any) => {
        try {
            const basCountData = await BasAdminReportService.searchCount(state.data.searchCriteria, state.routeInfo.pageName);
            dispatch({
                type: 'SET_INTERNAL_STATE',
                payload: { key: 'basCount', value: basCountData?.data },
            });
        } catch (error) {
            console.error('Error fetching alumni count:', error);
        }
    };

    const showStar = (row: any) => (row.isNotable && row.isNotable == 1 ? true : false);

    return (
        <>
        <div>
            <div className="ActiveListings_present">
                <div className="d-flex flex-wrap align-items-center mb-3 w-100 justify-content-between mailerLinks-parent">
                    <div className="d-flex flex-wrap align-items-center flex-1 mailerLinks my-2">
                        {config['BULK_ACTION'].length > 0 && (
                            <div className="d-flex justify-content-start align-items-center customselect_parnt">
                                <select
                                    name="complete Class 12"
                                    className="form-select w-120"
                                    onChange={(e) => setBulkAction(e.target.value)}>
                                    <option value={''}>Select</option>
                                    {config['BULK_ACTION'].map((action: string) => (
                                        <option key={action} value={action}>
                                            {getActionLabel(action)}
                                        </option>
                                    ))}
                                </select>
                                <button className="btn btn-darkblue" onClick={() => handlePerformAction(bulkAction, selectedRows)}>
                                    <span className="line-height-16">Apply</span>
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="d-flex flex-wrap align-items-center justify-content-end">
                        <h3 className="font-14 font-500 mb-0 me-2">
                            Total {state?.internal?.basCount && state?.internal?.basCount[0]?.totalBas} records
                        </h3>
                    </div>
                </div>
                <div className="table-responsive attendee_dtl min-h-420">
                    <table className={`table ${config.TABLE_CLASS}`} style={config.TABLE_STYLE}>
                        <thead>
                            <tr>
                                {resultsFormConfig.controlGroup.map((field: FormControl, index: number) => (
                                    // <th key={field.props.label} style={[0,1,2].includes(index) ? {'width': config['TABLE_WIDTH'][index]} : {}}>
                                    <th
                                        key={field.props.label}
                                        style={config?.TABLE_WIDTH?.length > index ? { width: config?.TABLE_WIDTH[index] } : {}}>
                                        {/* {!index && ( */}
                                        {!index && config['SHOW_SELECT_ALL'] && (
                                            <input
                                                type="checkbox"
                                                checked={selectedRows.length === allRowsData.length}
                                                id="Antony"
                                                className="form-check-input me-2 mt-0"
                                                onChange={handleSelectAll}
                                            />
                                        )}
                                        {field.props.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {pageData &&
                                pageData.map((row: any) => (
                                    <tr key={row?.uuid+''+row?.schoolId} className="">
                                        {resultsFormConfig.controlGroup.map((field: FormControl) => getFieldNode(field, row))}
                                    </tr>
                                ))}
                            <tr key="loadMoreRef" ref={loadMoreRef} />
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <Modal show={showCloseCaseModal} onHide={() => setShowCloseCaseModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Close Case</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <label htmlFor="comment">Add Comment</label>
    <textarea
      id="comment"
      className="form-control"
      value={comment}
      onChange={(e) => setComment(e.target.value)}
      placeholder="Enter reason or notes for closing case..."
    />
  </Modal.Body>
  <Modal.Footer>
    <button className="btn btn-secondary" onClick={() => setShowCloseCaseModal(false)}>Cancel</button>
    <button className="btn btn-danger" onClick={handleCloseCase}>Submit</button>
  </Modal.Footer>
</Modal>

       {state?.modalFlags?.addCounsellorSession && (
        <AssignSession />
        )}

      </>
    );
};

export default Results;
